// extracted by mini-css-extract-plugin
export var root = "styles-module--root--fqRv3";
export var hero = "styles-module--hero--1PDy0";
export var name = "styles-module--name--2qUsW";
export var intro = "styles-module--intro--2zgVO";
export var success = "styles-module--success--2_s4d";
export var error = "styles-module--error--2qvBy";
export var main = "styles-module--main--21pCz";
export var bold = "styles-module--bold--2TwpI";
export var emailLink = "styles-module--emailLink--1IK_6";